/**
 * Media and thumbnail URL normalizer for Zimetafsiriwa.
 * Ensures rock-solid cross-platform thumbnail loading across mobile browsers (iOS Safari, Android Chrome).
 */

export const DEFAULT_POSTER_SVG = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="300" height="420" viewBox="0 0 300 420"><rect width="100%" height="100%" fill="%231a1d24"/><g fill="none" stroke="%234f5565" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" transform="translate(110, 160) scale(3.5)"><rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"/><line x1="7" y1="2" x2="7" y2="22"/><line x1="17" y1="2" x2="17" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/><line x1="2" y1="7" x2="7" y2="7"/><line x1="2" y1="17" x2="7" y2="17"/><line x1="17" y1="17" x2="22" y2="17"/><line x1="17" y1="7" x2="22" y2="7"/></g><text x="50%" y="280" fill="%238a92a6" font-family="system-ui, sans-serif" font-size="14" font-weight="600" text-anchor="middle">ZIMETAFSIRIWA</text></svg>`;

/**
 * Normalizes media/thumbnail URL to resolve:
 * 1. Mixed-content blocking on mobile devices (http:// -> https://)
 * 2. Unencoded spaces and special characters breaking mobile WebKit parsing
 * 3. Legacy /storage/ and /api/media/ routes to /index.php/api/media/ on production LiteSpeed/Apache host
 * 4. Relative paths like thumbnails/xxx.jpg to absolute API URL
 */
export function normalizeMediaUrl(url) {
  if (!url || typeof url !== 'string') return '';

  let trimmed = url.trim();
  if (!trimmed) return '';

  // 1. Force HTTPS on non-local URLs to eliminate mobile mixed-content errors
  if (trimmed.startsWith('http://') && !trimmed.includes('localhost') && !trimmed.includes('127.0.0.1')) {
    trimmed = 'https://' + trimmed.slice(7);
  }

  // 2. Relative thumbnail/video paths stored in backend database
  if (trimmed.startsWith('/storage/') || trimmed.startsWith('storage/')) {
    const path = trimmed.replace(/^\/?storage\//, '');
    trimmed = `https://api.zimetafsiriwa.site/index.php/api/media/${path}`;
  } else if (trimmed.startsWith('/api/media/') || trimmed.startsWith('api/media/')) {
    const path = trimmed.replace(/^\/?api\/media\//, '');
    trimmed = `https://api.zimetafsiriwa.site/index.php/api/media/${path}`;
  } else if (trimmed.startsWith('thumbnails/') || trimmed.startsWith('/thumbnails/')) {
    const path = trimmed.replace(/^\/?thumbnails\//, '');
    trimmed = `https://api.zimetafsiriwa.site/index.php/api/media/thumbnails/${path}`;
  } else if (trimmed.startsWith('videos/') || trimmed.startsWith('/videos/')) {
    const path = trimmed.replace(/^\/?videos\//, '');
    trimmed = `https://api.zimetafsiriwa.site/index.php/api/media/videos/${path}`;
  } else if (trimmed.includes('api.zimetafsiriwa.site/api/media/')) {
    trimmed = trimmed.replace('api.zimetafsiriwa.site/api/media/', 'api.zimetafsiriwa.site/index.php/api/media/');
  } else if (trimmed.includes('api.zimetafsiriwa.site/storage/')) {
    trimmed = trimmed.replace('api.zimetafsiriwa.site/storage/', 'api.zimetafsiriwa.site/index.php/api/media/');
  }

  // 3. Safely encode unescaped spaces and URL characters for mobile browser compatibility
  try {
    if (trimmed.includes(' ')) {
      trimmed = encodeURI(trimmed);
    }
  } catch {
    trimmed = trimmed.replace(/ /g, '%20');
  }

  return trimmed;
}
